import { render } from "./ratingsTotals.vue?vue&type=template&id=6634db88"
import script from "./ratingsTotals.vue?vue&type=script&lang=js"
export * from "./ratingsTotals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__